module.exports = __webpack_public_path__ + "static/media/img2.7a52f0cc.jpg";